"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faTimesCircle_1 = require("@fortawesome/pro-solid-svg-icons/faTimesCircle");
var styles_1 = require("@mui/material/styles");
var general_1 = require("utils/general");
var SmallIcon_1 = __importDefault(require("../Icons/SmallIcon"));
exports.SearchButton = (0, styles_1.styled)('button', { shouldForwardProp: (0, general_1.omitProps)('visible') })(function (_a) {
    var theme = _a.theme, visible = _a.visible;
    return ({
        marginLeft: theme.spacing(0.75),
        width: 24,
        transition: 'visibility 20ms ease-in 0s',
        visibility: visible ? 'visible' : 'hidden',
        ' svg': {
            transition: 'opacity 20ms ease-in 0s',
            opacity: visible ? 1 : 0,
            borderRadius: '50%',
        },
        ':focus-visible': {
            ' svg': __assign(__assign({}, theme.focusVisibleStyles), theme.focusVisibleLinkStyles),
        },
    });
});
var ClearButton = function (_a) {
    var visible = _a.visible, props = __rest(_a, ["visible"]);
    return ((0, jsx_runtime_1.jsx)(exports.SearchButton, __assign({ visible: visible }, props, { children: (0, jsx_runtime_1.jsx)(SmallIcon_1.default, { icon: faTimesCircle_1.faTimesCircle }) })));
};
exports.default = ClearButton;
